(function() {
    angular.module('tmx-app').controller('LocationTrackingCtrl', ['$scope','$mdDialog','dynamicFormService', 
  
        function LocationTrackingCtrl($scope,$mdDialog,dynamicFormService) {			
            var LocationTrackingVM = $scope;
            var colorArray = ['#E74C3C','#9B59B6','#3498DB','#1ABC9C','#1ABC9C','#1ABC9C','#E67E22','#ECF0F1','#7F8C8D','#2E4053'];
            var distinctEventNames = [];
            LocationTrackingVM.TmxAuditTrail = dynamicFormService.applicationData.TmxAuditTrail;
            LocationTrackingVM.getPinIcon = getPinIcon;												
            LocationTrackingVM.getPostion = getPostion;
            LocationTrackingVM.showMarkerInfo = showMarkerInfo;

		
            if(LocationTrackingVM.TmxAuditTrail) {
                distinctEventNames = LocationTrackingVM.TmxAuditTrail.map(item => item.EventName).filter((value, index, self) => self.indexOf(value) === index);
            }	
		
            function getPinIcon(tat) {
                return { 	
                    path: 'M11.513,12.38c-2.117,0-3.835-1.729-3.835-3.862c0-2.135,1.718-3.863,3.835-3.863s3.835,1.729,3.835,3.863  C15.348,10.65,13.63,12.38,11.513,12.38 M11.513,0C6.825,0,3.025,3.827,3.025,8.549c0,4.46,3.844,10.213,6.411,13.014  c0.959,1.045,2.076,2.454,2.076,2.454s1.2-1.417,2.229-2.493C16.306,18.84,20,13.451,20,8.549C20,3.827,16.2,0,11.513,0',
                    fillColor: colorArray[distinctEventNames.indexOf(tat.EventName)],
                    fillOpacity: 1,
                    scale: 1.5,
                    strokeColor: 'black',
                    strokeWeight: 1
                }
            }
            function getPostion(TmXGeoTracking) {
                return "[" + TmXGeoTracking.Latitude + "," + TmXGeoTracking.Longitude + "]"
            }

		//Dialogs for Markers
            function showMarkerInfo(ev,Description) {

                $mdDialog.show({
                    controller: DialogController,
                    template: '<md-dialog style="width:30%;" aria-label="Marker Info">' +
                '<md-toolbar>'+
                '<div class="md-toolbar-tools">'+
                '<h2>{{"Description"|translate}}</h2>'+
                '</div>'+
                '</md-toolbar>'+
                '  <md-dialog-content >' +
                '      <div layout-padding class="padding-left-right-12" layout="column">' +
                '       <div layout="row" flex layout-align="start center"><strong>Event:  </strong> {{Description.EventName}} </div>' +
                '       <div layout="row" flex layout-align="start center"><strong>Time:  </strong> {{TimeStampFormatting(Description.TmXGeoTracking.CreatedDate)}}</div>' +
				'       <div layout="row" flex layout-align="start center"><strong>Created By:  </strong> {{Description.TmXGeoTracking.CreatedBy}}</div>' +
				'       <div layout="row" flex layout-align="start center"><strong>Latitude:  </strong> {{Description.TmXGeoTracking.Latitude}}</div>' +
				'       <div layout="row" flex layout-align="start center"><strong>Longitude	:  </strong> {{Description.TmXGeoTracking.Longitude}}</div>' +
                '    </div>' +
                '  </md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                    locals: {
                        Description: Description
                    },
                    targetEvent: ev,
                    clickOutsideToClose:false,

                });
            }

            function DialogController($scope, $mdDialog, Description,tmxUtility) {
                $scope.Description = Description;
                $scope.TimeStampFormatting = tmxUtility.formatDateTimeForCompany;
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
		
		
        }]);
})();